<script>
  import RetryPage from "../../../Shared/retryPage.svelte"
  import Progress from "../../../Shared/progress.svelte"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  /**
   * @type {string} name of the start button based on conditions
   */
  export let startBtnName
  /**
   * @type {"start"|"processing"|"completed"|"retry"} active item in document status tab
   */
  export let activeDoc
  /**
   * @type {number} width of the progress bar
   */
  export let width
  /**
   * @type {boolean} whether to show the "Send Email" btn or not
   */
  export let showEmailButton
</script>

{#if activeDoc == "start"}
  <div class="mt-6 flex w-full justify-center text-center text-base text-gray-400 mobile:w-3/4 md:w-1/2">
    {#if startBtnName == "Publish"}
      <h1>To begin the process, click the button to sign and publish documents.</h1>
    {:else}
      <h1>To proceed with the procedure, press the "Resume" button to sign and publish the remaining documents.</h1>
    {/if}
  </div>
  <div class="mt-6">
    <button on:click type="button" class="flex h-9 w-32 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] {startBtnName == 'Publish' ? 'bg-green-500 hover:bg-green-600 active:bg-green-500 disabled:bg-green-500/50' : 'bg-blue-500 hover:bg-blue-600 active:bg-blue-500 disabled:bg-blue-500/50'} px-2 text-sm font-medium text-white hover:text-white focus:outline-none disabled:cursor-not-allowed lg:px-4">
      <span>
        <i class="fa-solid fa-circle-play" />
      </span>
      <span class="select-none">&nbsp;&nbsp;{startBtnName}&nbsp;</span>
    </button>
  </div>
{:else if activeDoc == "processing"}
  <Progress {width} content="Publishing Documents" />
{:else if activeDoc == "completed"}
  <div class="mt-12 flex w-full items-center justify-center gap-3 text-center text-3xl font-bold text-green-500 mobile:w-4/5 lg:w-3/5">
    <i class="fa-solid fa-circle-check" />
    <h1 class="text-2xl">Process Completed</h1>
  </div>
  <div class="mt-6 flex w-full justify-center text-center text-base text-gray-400 mobile:w-4/5 lg:w-3/5">
    <h1>The files have been successfully published. {showEmailButton ? "You can download the report or send emails to the respective document holders" : "You can download the report"}, by click in the button below.</h1>
  </div>
  <div class="mt-12 flex w-full flex-col justify-center gap-3 mobile:flex-row">
    {#if showEmailButton}
      <button
        on:click={() => {
          dispatch("sendEmail")
        }}
        type="button"
        class="disabled:text-white-200/50 flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-green-500 px-4 text-sm font-medium text-white hover:bg-green-600 hover:text-white focus:outline-none active:bg-green-500 disabled:cursor-not-allowed disabled:bg-green-200/50"
      >
        <i class="fa-solid fa-envelope" />
        <span class="select-none">&nbsp;&nbsp;Send&nbsp;Email&nbsp;for&nbsp;Documents&nbsp;</span>
      </button>
    {/if}
    <button
      on:click={() => {
        dispatch("viewReport")
      }}
      type="button"
      class="normal-blue-btn disabled:text-white-200/50 disabled:cursor-not-allowed disabled:bg-blue-200/50"
    >
      <span><i class="fa-solid fa-eye" /></span>
      <span class="select-none">&nbsp;&nbsp;View&nbsp;and&nbsp;Download&nbsp;Report&nbsp;</span>
    </button>
  </div>
{:else}
  <RetryPage content="A few documents encountered failures during the signature and publish process. Please consider retrying to proceed." />
{/if}

<style lang="postcss">
  .normal-blue-btn {
    @apply flex h-9 items-center justify-center rounded-md border border-[#a0a1a580] bg-blue-500 px-4 text-sm font-medium text-white hover:bg-blue-600 hover:text-white focus:outline-none active:bg-blue-500;
  }
</style>
